import {useEffect} from 'react';

/**
 * Invokes `handler` on any scroll. Listens on window in the capture phase so
 * scrolls inside nested containers are caught too (scroll events don't bubble).
 */
function useOnScroll(handler: (e: Event) => void) {
  useEffect(() => {
    window.addEventListener('scroll', handler, true);

    return () => {
      window.removeEventListener('scroll', handler, true);
    };
  }, [handler]);
}

export default useOnScroll;
